const IMG_BASE_URL = 'https://www.camas.app/resources/static/images/proposals/';
const CONDENSED = 'condensed'
const FULL = 'full'

export {
  IMG_BASE_URL,
  CONDENSED,
  FULL
}
